// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1blUg","requiredAsterisk":"Info_requiredAsterisk__1bram"};